import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import InventoryDetailPage from "@project/admin/pages/modules/gruh-udhyog/inventory-detail";

const searchSchema = z.object({
  productId: z.number().int().positive(),
});

export const Route = createFileRoute("/admin/_modules/_gruh-udhyog/inventory/")(
  {
    validateSearch: searchSchema,
    component: function InventoryDetailRoute() {
      const { variantId } = Route.useParams();
      const { productId } = Route.useSearch();
      return (
        <InventoryDetailPage
          variantId={Number(variantId)}
          productId={productId}
        />
      );
    },
  }
);
